import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ChatSoporteService {

  usuario = JSON.parse(localStorage.getItem("user"))
  chat = [];
  constructor(private afs: AngularFirestore) { }


  validar(id) {
    return this.afs.collection("usuariosChat").doc(this.usuario.uid).ref.get().then(async doc => {
      if (!doc.exists) {
        await this.afs.collection("usuariosChat").doc(this.usuario.uid).set({
          id: this.usuario.uid,
          nombre: this.usuario.nombreCompleto,
          chat: [],
          status: "Sin atender",
          timestamp: new Date(),
        })
      }
      return console.log("chat creado");
    })
  }
  getChat(id) {
      return this.afs.collection("usuariosChat").doc(id).snapshotChanges();
  }

  async pushMessage(id, data) {
    const timestamp = new Date();
    const usuario = data.usuario;
    const mensaje = data.mensaje;
    const admin = data.admin;
    const msg = {
      timestamp: timestamp,
      usuario: usuario,
      mensaje: mensaje,
      admin: admin,
      leido: "no leido"
    }
    let newChat = []
    await this.afs.collection("usuariosChat").doc(id).ref.get().then(async doc => {
      if (doc.exists) {
        newChat = doc.data()["chat"].concat(msg);
      } else {
        newChat = newChat.concat(msg);
      }
    })
    this.afs.doc(`usuariosChat/${id}`).set({chat: newChat, timestamp: new Date(),}, {merge: true});
  }

  actualizarStatus(id, status) {
    this.afs.doc(`usuariosChat/${id}`).set({status: status}, {merge: true});
  }

  async leido (id) {
    // console.log("entre a leido del soporte de usuario")
    const doc = await this.afs.doc(`usuariosChat/${id}`).ref.get();
    const chat = doc.data()["chat"];
    for (let index = 0; index < chat.length; index++) {
      if (chat[index].admin == true) {
        chat[index].leido = "leido"
      }      
    }
    console.log(chat)
    await this.afs.doc(`usuariosChat/${id}`).update({
      chat: chat,
    })
  }
}
